// store.js
import { configureStore } from '@reduxjs/toolkit';

import billDataSlice from '../views/counterBilling/slice/BillDataSlice'
import billTableSlice from '../views/counterBilling/slice/billTableSlice'

import quotationSlice from '../views/quotation/slice/QuotationTable'
import quotationDataSlice from '../views/quotation/slice/QuotationData'
import privilegeSlice from './privileges/privilegeSlice';

const store = configureStore({
  reducer: {
    billMaster:billDataSlice,
    billTable:billTableSlice,

    quotationTable:quotationSlice,
    quotationMaster:quotationDataSlice,
    privilegeSlice
 
  },
});

export default store;
